<template>
    <modal @close="$emit('close')" :show-title="true" :size="'medium'">
        <div slot="header">
            <h5 class="modal-title">{{$t('premi_accumulati')}}</h5>
        </div>
        <div slot="body">
            <div class="content content-full" style="min-height: 200px;">
                <div class="container">
                    <div class="row-sezione text-center" style="padding-top:0;">
                        <div class="blocchetto" v-for="reward in this.rewards">
                            {{$t('premio')}}:<br>
                            <b class="f2">
                                <inc-reward-name :reward="reward" :type="reward.tipo"/>
                            </b>
                            <br>
                            <span class="color">
                                {{$t("valido_dal")}}
                                {{moment(reward.data_inizio).format('DD/MM/YYYY')}}
                                {{$t("al")}}
                                {{moment(reward.data_scadenza).format('DD/MM/YYYY')}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
    import {mapGetters} from 'vuex';

    import Modal from '../../partials/Modal';
    import IncRewardName from '../../fidelity/partials/IncRewardName';

    export default {
        name: "ModalRewards",
        components: {IncRewardName, Modal},
        props: ['rewards'],
        computed: {
            ...mapGetters('restaurant', {
                locale_currency: 'localeCurrency'
            })
        }
    }
</script>
